import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease }}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`mask-line ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`font-mono text-xs tracking-[0.3em] uppercase ${
      dark ? "text-petal-soft" : "text-petal"
    }`}
  >
    {children}
  </p>
);
